function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var T = Object.defineProperty;
var R = Object.getOwnPropertyDescriptor;
var e = function e(h, u, t, a) {
  for (var r = a > 1 ? void 0 : a ? R(u, t) : u, l = h.length - 1, g; l >= 0; l--) (g = h[l]) && (r = (a ? g(u, t, r) : g(r)) || r);
  return a && r && T(u, t, r), r;
};
import { html as w, LitElement as A } from "lit";
import { classMap as E } from "lit/directives/class-map.js";
import { property as n } from "lit/decorators/property.js";
import { customElement as $ } from "lit/decorators/custom-element.js";
import { mintingContractTypes as U, onboardingRequestStatusResponse as _, crossmintStatusService as j, crossmintModalService as D, crossmintPayButtonService as V, clientNames as O } from "@crossmint/client-sdk-base";
var y = "0.1.7";
import { css as N } from "lit";
var S = N(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    button {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        padding: 0.875rem 0.875rem;\n        font-weight: 900;\n        transition: opacity ease-in-out 0.25s;\n        border-radius: 0.5rem;\n        font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans,\n            Helvetica Neue, sans-serif;\n        outline: none;\n        border: none;\n        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n        justify-content: center;\n        background: #1e1e1e;\n        color: white;\n    }\n    button.light {\n        background: white;\n    }\n\n    button:hover:enabled {\n        opacity: 0.6;\n        cursor: pointer;\n    }\n\n    img {\n        width: 21px;\n        height: 21px;\n        margin-right: 0.875rem;\n    }\n\n    p {\n        color: white;\n        margin: 0;\n    }\n\n    button.light p {\n        color: black;\n    }\n"])));
var s = {
    className: "",
    theme: "dark",
    disabled: !1,
    tabIndex: 0,
    mintTo: "",
    emailTo: "",
    listingId: "",
    clientId: "",
    auctionId: "",
    environment: "",
    hideMintOnInactiveClient: !1,
    showOverlay: !0,
    mintConfig: {
      type: U.CANDY_MACHINE
    },
    onClick: void 0,
    whPassThroughArgs: void 0,
    paymentMethod: void 0,
    preferredSigninMethod: void 0,
    dismissOverlayOnClick: !1,
    prepay: !1,
    locale: "en-US",
    currency: "usd",
    successCallbackURL: "",
    failureCallbackURL: ""
  },
  i = /*#__PURE__*/function (_A) {
    function i() {
      var _this;
      _classCallCheck(this, i);
      _this = _callSuper(this, i, arguments);
      _this.theme = s.theme;
      _this.disabled = s.disabled;
      _this.mintTo = s.mintTo;
      _this.emailTo = s.emailTo;
      _this.listingId = s.listingId;
      _this.clientId = s.clientId;
      _this.auctionId = s.auctionId;
      _this.environment = s.environment;
      _this.hideMintOnInactiveClient = s.hideMintOnInactiveClient;
      _this.showOverlay = s.showOverlay;
      _this.mintConfig = {
        type: U.CANDY_MACHINE
      };
      _this.onClick = s.onClick;
      _this.whPassThroughArgs = s.whPassThroughArgs;
      _this.paymentMethod = s.paymentMethod;
      _this.preferredSigninMethod = s.preferredSigninMethod;
      _this.dismissOverlayOnClick = s.dismissOverlayOnClick;
      _this.prepay = s.prepay;
      _this.locale = s.locale;
      _this.currency = s.currency;
      _this.successCallbackURL = s.successCallbackURL;
      _this.failureCallbackURL = s.failureCallbackURL;
      _this.connecting = !1;
      _this.setConnecting = function (t) {
        _this.connecting = t;
      };
      _this.status = _.WAITING_SUBMISSION;
      _this.setStatus = function (t) {
        _this.status = t;
      };
      _this.classes = {
        light: !1
      };
      _this.statusService = null;
      _this.modalService = null;
      return _this;
    }
    _inherits(i, _A);
    return _createClass(i, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(i.prototype), "connectedCallback", this).call(this);
        var _j = j({
            libVersion: y,
            clientId: this.clientId,
            environment: this.environment,
            auctionId: this.auctionId,
            mintConfig: this.mintConfig,
            setStatus: this.setStatus,
            clientName: O.vanillaUi
          }),
          t = _j.fetchClientIntegration;
        this.hideMintOnInactiveClient && t();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _V = V({
            onClick: this.onClick,
            connecting: this.connecting,
            paymentMethod: this.paymentMethod,
            locale: this.locale || "en-US"
          }),
          t = _V.shouldHideButton,
          a = _V.handleClick,
          r = _V.getButtonText;
        if (t({
          hideMintOnInactiveClient: this.hideMintOnInactiveClient,
          status: this.status
        })) return w(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
        var l = r(this.connecting),
          _D = D({
            environment: this.environment,
            clientId: this.clientId,
            showOverlay: this.showOverlay || !0,
            dismissOverlayOnClick: this.dismissOverlayOnClick,
            setConnecting: this.setConnecting,
            libVersion: y,
            clientName: O.vanillaUi,
            locale: this.locale || "en-US",
            currency: this.currency || "usd",
            successCallbackURL: this.successCallbackURL,
            failureCallbackURL: this.failureCallbackURL
          }),
          g = _D.connect,
          v = function v(C) {
            return a(C, function () {
              g(_this2.mintConfig, _this2.mintTo, _this2.emailTo, _this2.listingId, _this2.whPassThroughArgs, _this2.paymentMethod, _this2.preferredSigninMethod, _this2.prepay, _this2.successCallbackURL, _this2.failureCallbackURL);
            });
          };
        return this.classes.light = this.theme === "light", w(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            <button\n                class=", "\n                .disabled=", "\n                @click=", "\n                tabindex=", "\n                part=\"button\"\n            >\n                <img src=\"https://www.crossmint.io/assets/crossmint/logo.svg\" alt=\"Crossmint logo\" />\n                <span part=\"contentParagraph\">", "</span>\n            </button>\n        "])), E(this.classes), this.disabled, v, this.tabIndex, l);
      }
    }]);
  }(A);
i.styles = S, e([n({
  type: String
})], i.prototype, "theme", 2), e([n({
  type: Boolean
})], i.prototype, "disabled", 2), e([n({
  type: String
})], i.prototype, "mintTo", 2), e([n({
  type: String
})], i.prototype, "emailTo", 2), e([n({
  type: String
})], i.prototype, "listingId", 2), e([n({
  type: String
})], i.prototype, "clientId", 2), e([n({
  type: String
})], i.prototype, "auctionId", 2), e([n({
  type: String
})], i.prototype, "environment", 2), e([n({
  type: Boolean
})], i.prototype, "hideMintOnInactiveClient", 2), e([n({
  type: Boolean
})], i.prototype, "showOverlay", 2), e([n({
  type: Object
})], i.prototype, "mintConfig", 2), e([n({
  type: Function
})], i.prototype, "onClick", 2), e([n({
  type: Object
})], i.prototype, "whPassThroughArgs", 2), e([n({
  type: String
})], i.prototype, "paymentMethod", 2), e([n({
  type: String
})], i.prototype, "preferredSigninMethod", 2), e([n({
  type: Boolean
})], i.prototype, "dismissOverlayOnClick", 2), e([n({
  type: Boolean
})], i.prototype, "prepay", 2), e([n({
  type: String
})], i.prototype, "locale", 2), e([n({
  type: String
})], i.prototype, "currency", 2), e([n({
  type: String
})], i.prototype, "successCallbackURL", 2), e([n({
  type: String
})], i.prototype, "failureCallbackURL", 2), i = e([$("crossmint-pay-button")], i);
import { html as F, LitElement as q } from "lit";
import { classMap as H } from "lit/directives/class-map.js";
import { property as m } from "lit/decorators/property.js";
import { customElement as G } from "lit/decorators/custom-element.js";
import { crossmintStatusService as M, onboardingRequestStatusResponse as W, clientNames as x, crossmintStatusButtonService as Y } from "@crossmint/client-sdk-base";
var f = {
    className: "",
    theme: "dark",
    disabled: !1,
    tabIndex: 0,
    clientId: "",
    auctionId: "",
    environment: "",
    platformId: "",
    mintConfig: {},
    onClick: void 0,
    locale: "en-US"
  },
  c = /*#__PURE__*/function (_q) {
    function c() {
      var _this3;
      _classCallCheck(this, c);
      _this3 = _callSuper(this, c, arguments);
      _this3.theme = f.theme;
      _this3.disabled = f.disabled;
      _this3.clientId = f.clientId;
      _this3.auctionId = f.auctionId;
      _this3.environment = f.environment;
      _this3.mintConfig = {};
      _this3.onClick = f.onClick;
      _this3.locale = f.locale;
      _this3.status = W.WAITING_SUBMISSION;
      _this3.setStatus = function (t) {
        _this3.status = t;
      };
      _this3.classes = {
        light: !1
      };
      _this3.interval = null;
      return _this3;
    }
    _inherits(c, _q);
    return _createClass(c, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(c.prototype), "connectedCallback", this).call(this);
        var _M = M({
            libVersion: y,
            clientId: this.clientId,
            environment: this.environment,
            auctionId: this.auctionId,
            mintConfig: this.mintConfig,
            setStatus: this.setStatus,
            clientName: x.vanillaUi
          }),
          t = _M.fetchClientIntegration;
        t(), this.interval = setInterval(function () {
          t();
        }, 60 * 1e3);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        clearInterval(this.interval);
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;
        var _Y = Y({
            onClick: this.onClick,
            locale: this.locale || "en-US"
          }),
          t = _Y.getButtonText,
          a = _Y.isButtonDisabled,
          r = _Y.handleClick,
          _M2 = M({
            libVersion: y,
            clientId: this.clientId,
            environment: this.environment,
            auctionId: this.auctionId,
            mintConfig: this.mintConfig,
            setStatus: this.setStatus,
            clientName: x.vanillaUi
          }),
          l = _M2.goToOnboarding,
          g = t(this.status),
          v = a(this.status) || this.disabled,
          C = function C(L) {
            return r(L, _this4.status, l);
          };
        return this.classes.light = this.theme === "light", F(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            <button\n                class=", "\n                .disabled=", "\n                @click=", "\n                tabindex=", "\n            >\n                <img src=\"https://www.crossmint.io/assets/crossmint/logo.svg\" alt=\"Crossmint logo\" />\n                <span>", "</span>\n            </button>\n        "])), H(this.classes), v, C, this.tabIndex, g);
      }
    }]);
  }(q);
c.styles = S, e([m({
  type: String
})], c.prototype, "theme", 2), e([m({
  type: Boolean
})], c.prototype, "disabled", 2), e([m({
  type: String
})], c.prototype, "clientId", 2), e([m({
  type: String
})], c.prototype, "auctionId", 2), e([m({
  type: String
})], c.prototype, "environment", 2), e([m({
  type: Object
})], c.prototype, "mintConfig", 2), e([m({
  type: Function
})], c.prototype, "onClick", 2), e([m({
  type: String
})], c.prototype, "locale", 2), c = e([G("crossmint-status-button")], c);
import { LitElement as Q, html as z } from "lit";
import { property as p } from "lit/decorators.js";
import { crossmintPaymentService as k, crossmintUiService as J } from "@crossmint/client-sdk-base";
import { customElement as K } from "lit/decorators/custom-element.js";
var d = {
    clientId: "",
    mintConfig: {},
    recipient: {
      email: "",
      wallet: ""
    },
    paymentMethod: "fiat",
    currency: "usd",
    locale: "en-US",
    uiConfig: {},
    environment: "production",
    whPassThroughArgs: void 0,
    onEvent: void 0
  },
  o = /*#__PURE__*/function (_Q) {
    function o() {
      var _this5;
      _classCallCheck(this, o);
      _this5 = _callSuper(this, o, arguments);
      _this5.clientId = d.clientId;
      _this5.mintConfig = d.mintConfig;
      _this5.recipient = d.recipient;
      _this5.paymentMethod = d.paymentMethod;
      _this5.currency = d.currency;
      _this5.locale = d.locale;
      _this5.uiConfig = d.uiConfig;
      _this5.environment = d.environment;
      _this5.whPassThroughArgs = d.whPassThroughArgs;
      _this5.onEvent = d.onEvent;
      _this5.height = 0;
      _this5.removeEventListener = function () {};
      _this5.removeUIEventListener = function () {};
      return _this5;
    }
    _inherits(o, _Q);
    return _createClass(o, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this6 = this;
        _get(_getPrototypeOf(o.prototype), "connectedCallback", this).call(this);
        var t = X(this.onEvent),
          _k = k({
            clientId: this.clientId,
            environment: this.environment,
            uiConfig: this.uiConfig,
            recipient: this.recipient,
            mintConfig: this.mintConfig,
            whPassThroughArgs: this.whPassThroughArgs
          }),
          a = _k.listenToEvents,
          _J = J({
            environment: this.environment
          }),
          r = _J.listenToEvents;
        this.removeEventListener = a(function (l) {
          return t == null ? void 0 : t(l.data);
        }), this.removeUIEventListener = r(function (l) {
          var _l$data = l.data,
            g = _l$data.type,
            v = _l$data.payload;
          switch (g) {
            case "ui:height.changed":
              _this6.height = v.height, _this6.requestUpdate();
              break;
            default:
              return;
          }
        });
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(o.prototype), "disconnectedCallback", this).call(this), this.removeEventListener(), this.removeUIEventListener();
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(o.prototype), "updated", this).call(this, t);
        var _k2 = k({
            clientId: this.clientId,
            environment: this.environment,
            uiConfig: this.uiConfig,
            recipient: this.recipient,
            mintConfig: this.mintConfig
          }),
          a = _k2.emitQueryParams;
        (t.has("recipient") || t.has("mintConfig") || t.has("locale") || t.has("whPassThroughArgs")) && a({
          recipient: this.recipient,
          mintConfig: this.mintConfig,
          locale: this.locale,
          whPassThroughArgs: this.whPassThroughArgs
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _k3 = k({
            clientId: this.clientId,
            environment: this.environment,
            uiConfig: this.uiConfig,
            recipient: this.recipient,
            mintConfig: this.mintConfig
          }),
          t = _k3.getIframeUrl;
        return z(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      <iframe\n        src=", "\n        allow=\"payment *\"\n        id=\"iframe-crossmint-payment-element\"\n        style=\"border: none !important;\n        padding: 0px !important;\n        width: 100% !important;\n        min-width: 100% !important;\n        overflow: hidden !important;\n        display: block !important;\n        user-select: none !important;\n        transform: translate(0px) !important;\n        opacity: 1;\n        transition: ease 0s, opacity 0.4s ease 0.1s;\n        height: ", "px;\"\n      ></iframe>\n    "])), t(), this.height);
      }
    }]);
  }(Q);
e([p({
  type: String
})], o.prototype, "clientId", 2), e([p({
  type: Object
})], o.prototype, "mintConfig", 2), e([p({
  type: Object
})], o.prototype, "recipient", 2), e([p({
  type: String
})], o.prototype, "paymentMethod", 2), e([p({
  type: String
})], o.prototype, "currency", 2), e([p({
  type: String
})], o.prototype, "locale", 2), e([p({
  type: Object
})], o.prototype, "uiConfig", 2), e([p({
  type: String
})], o.prototype, "environment", 2), e([p({
  type: Object
})], o.prototype, "whPassThroughArgs", 2), e([p({
  type: Function || String
})], o.prototype, "onEvent", 2), o = e([K("crossmint-payment-element")], o);
function X(h) {
  if (!!h) return typeof h == "string" ? new Function(h)() : h;
}
import { CheckoutEvents as xe, useCrossmintEvents as Le } from "@crossmint/client-sdk-base";
export { xe as CheckoutEvents, i as CrossmintPayButton, o as CrossmintPaymentElement, c as CrossmintStatusButton, Le as useCrossmintEvents };